import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FeaturesConfigModule, I18nModule, provideConfig, UrlModule } from '@spartacus/core';
import { AtMessageModule, IconModule, MediaModule, OutletModule, provideOutlet } from '@spartacus/storefront';
import { CustomItemCounterModule } from '../../../../product/item-counter/item-counter.module';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CustomAddToCartModule } from '../../../../product/add-to-cart/add-to-cart.module';
import { CartOutlets } from '@spartacus/cart/base/root';
import { CustomCartItemListComponent } from './cart-item-list/cart-item-list.component';
import { CustomCartItemListRowComponent } from './cart-item-list-row';
import { CustomOrderSummaryComponent } from './order-summary/order-summary.component';
import { CustomCartItemValidationWarningModule } from '../../../validation/cart-item-warning/cart-item-validation-warning.module';
import { CustomCartItemComponent } from './cart-item/cart-item.component';
import { CustomCartCouponModule } from '../cart-coupon';
import { CustomPromotionsModule } from '../../../../store-front/misc/cms-components/promotions';
import { CheckInventoryModule } from '../../../../product/check-inventory/check-inventory.module';
import { DatePickerModule } from 'primeng/datepicker';
import { activeCartOccContentConfig } from '../../../_core/active-cart.occ';
import { TooltipModule } from 'primeng/tooltip';
import { ScreenViewModule } from '../../../../../../core/directives/screen-view/_screen-view.module';
import { CartFreeShippingMessageComponent } from './cart-free-shipping-message/cart-free-shipping-message.component';
import { TooltipIconComponent } from '../../../../../../components/tooltip-icon/tooltip-icon.component';
import { ProductMediaComponent } from '../../../../product/product-media/product-media.component';
import { AllowedKeysToDatePickerModule } from '../../../../../../core/directives/allowed-keys-to-date-picker/allowed-keys-to-date-picker.module';
import { cartAuxOccConfig } from '../../../_core/cart-aux.occ';

@NgModule({
  imports: [
    AtMessageModule,
    CustomCartCouponModule,
    CustomCartItemValidationWarningModule,
    CommonModule,
    I18nModule,
    IconModule,
    CustomItemCounterModule,
    MediaModule,
    OutletModule,
    CustomPromotionsModule,
    ReactiveFormsModule,
    RouterModule,
    UrlModule,
    CustomAddToCartModule,
    FeaturesConfigModule,
    CheckInventoryModule,
    DatePickerModule,
    TooltipModule,
    ScreenViewModule,
    CartFreeShippingMessageComponent,
    TooltipIconComponent,
    ProductMediaComponent,
    AllowedKeysToDatePickerModule,
  ],
  providers: [
    provideOutlet({
      id: CartOutlets.ORDER_SUMMARY,
      component: CustomOrderSummaryComponent,
    }),
    provideOutlet({
      id: CartOutlets.CART_ITEM_LIST,
      component: CustomCartItemListComponent,
    }),

    provideConfig(activeCartOccContentConfig),
    provideConfig(cartAuxOccConfig),
  ],
  declarations: [
    CustomCartItemComponent,
    CustomOrderSummaryComponent,
    CustomCartItemListComponent,
    CustomCartItemListRowComponent,
  ],
  exports: [
    CustomCartItemComponent,
    CustomCartItemListRowComponent,
    CustomCartItemListComponent,
    CustomOrderSummaryComponent,
  ],
})
export class CustomCartSharedModule {}
